<template>
  <div style="background: #f2f2f6; height: 100%">
    <el-form size="mini" label-width="100px" class="demo-form-inline">
      <el-row>
        <el-col :span="10" style="text-align:left">
      <el-form-item :label="$t('base.timeInterval')">
    <el-date-picker
v-model="where.betweendate"
type="datetimerange"
:range-separator="$t('base.to')"
:start-placeholder="$t('base.beginTime')"
size="mini"
value-format="yyyy-MM-dd HH:mm:ss"
:default-time="['00:00:00','23:59:59']"
:end-placeholder="$t('base.endTime')">
</el-date-picker>
</el-form-item>
</el-col>
<el-col :span="5">
<el-form-item label="">
</el-form-item>
</el-col>
<el-col :span="5">
<el-form-item label="">
</el-form-item>
</el-col>
<el-col :span="4" style="text-align:right">
  <el-button size="small" type="primary" @click="searchLog()">{{this.$t("base.search")}}</el-button>
</el-col>
</el-row>
</el-form>
        <el-table
          id="logtable"
          :data="tabledata"
          v-loading="loading"
          ref="table"
          border
          stripe
          style="width: 100%; border-radius: 0 0 10px 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }">
           <el-table-column
            type="index"
            :index="indexMethod"
            width="65">
          </el-table-column>
          <el-table-column prop="version" :label="$t('device.updatedVersion')" >
            <template slot-scope="scope">
              <span>{{ scope.row.oldversion||$t('device.unknowVersion')}}--->{{scope.row.versionno+(scope.row.eversionno?('-'+scope.row.eversionno):'')}}（{{scope.row.version  }}）</span>
            </template>
          </el-table-column>
          <el-table-column prop="runtime" :label="$t('device.updateTime')" width="200">
          </el-table-column>
          <el-table-column prop="result" :label="$t('device.result')"  width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.result==1" style="color:green">{{$t('device.updateVersionSuccess')}}</span>
              <span v-else-if="scope.row.result==2" style="color:green">{{$t('device.noNeedUpdateVserion')}}</span>
              <span v-else-if="scope.row.result==3" style="color:red">{{$t('device.updateVersionOffline')}}</span>
              <span v-else-if="scope.row.result==-1" style="color:red">{{$t('device.updateVersionFial')}}</span>
              <span v-else style="color:gray">{{$t('device.updateVersionUnkonow')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="$t('device.optBy')" width="150">
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 10px;margin-bottom:10px"
        >
        </el-pagination>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ErrorPage',
  data () {
    return {
      tabledata: [],
      loading: true,
      where:{
        srcaddress:this.$store.state.project.srcaddress,
        betweendate: []
      },
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0
    }
  },
  computed: {
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      if(this.$store.state.project.srcaddress){
        self.searchLog()
      }else{
        setTimeout(()=>{
          self.searchLog()
        },4000)
      }
        
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'error'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    searchLog () {
      this.where.srcaddress=this.$store.state.project.srcaddress
      var self = this
      self.loading = true
      Vue.axios
        .post('/equipment/version/log/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
          self.loading = false
        })
      Vue.axios
        .post('/equipment/version/log/count', {
          where: this.where,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchLog()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchLog()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Devices/VersionLog.vue